import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export const NotAccess = () => {
	const navigate = useNavigate();

	return (
		<div className="flex items-center justify-center min-h-[400px] px-4">
			<div className="rounded-lg border bg-card p-8 text-center max-w-md w-full">
				<div className="flex justify-center mb-4">
					<div className="rounded-full bg-destructive/10 p-3">
						<AlertTriangle className="h-6 w-6 text-destructive" />
					</div>
				</div>
				<h2 className="text-2xl font-bold text-foreground mb-2">403</h2>
				<p className="text-muted-foreground mb-6">
					Bạn không có quyền truy cập trang này
				</p>
				<Button 
					variant="outline" 
					onClick={() => navigate('/')}
					className="w-full"
				>
					Quay lại trang chủ
				</Button>
			</div>
		</div>
	);
};
